import * as React from "react";

import { Box, Link, Typography } from "@material-ui/core";

import { MerchantAgreementLink } from "client/domain/Link/MerchantAgreementLink";
import { Translate } from "client/utils/internationalization";

import { useStyles } from "./styles";
import { FAQ } from "./types";

export const getAboutAfterpayFaqs = (
  t: Translate,
  classes: ReturnType<typeof useStyles>
): FAQ[] => [
  {
    question: t("uiFaqAboutAfterpayWhatIsAfterpayQuestion"),
    answer: (
      <>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqAboutAfterpayWhatIsAfterpayAnswer1")}
        </Typography>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqAboutAfterpayWhatIsAfterpayAnswer2")}
        </Typography>
      </>
    ),
  },
  {
    question: t("uiFaqAboutAfterpayCanISellInternationallyQuestion"),
    answer: (
      <Box>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqAboutAfterpayCanISellInternationallyAnswer1")}
        </Typography>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqAboutAfterpayCanISellInternationallyAnswer2")}
          <Link
            href={t("uiFaqAboutAfterpayCanISellInternationallyAnswerLink")}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("uiFaqAboutAfterpayCanISellInternationallyAnswerLinkText")}
          </Link>
        </Typography>
      </Box>
    ),
  },
  {
    question: t("uiFaqAboutAfterpayECommerceQuestion"),
    answer: (
      <Box>
        <Typography variant="body2">
          {t("uiFaqAboutAfterpayECommerceAnswer1")}
        </Typography>
        <Box className={classes.paragraph}>
          <ul>
            <li>Shopify</li>
            <li>WooCommerce</li>
            <li>Stripe</li>
            <li>Adyen</li>
            <li>Magento &amp; Magento 2</li>
            <li>BigCommerce</li>
            <li>Spree</li>
            <li>Salesforce Commerce Cloud</li>
            <li>Squarespace</li>
            <li>Wix</li>
            <li>Acadaca</li>
            <li>Workarea</li>
            <li>Ecwid</li>
          </ul>
        </Box>
        <Typography variant="body2" className={classes.paragraph}>
          {t("uiFaqAboutAfterpayECommerceAnswer2")}
          <Link
            href={t("uiFaqAboutAfterpayECommerceSupportUrl")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("uiFaqAboutAfterpayECommerceLinkText")}
          </Link>
        </Typography>
        <Typography variant="body2" className={classes.paragraph}>
          {t("uiFaqAboutAfterpayECommerceAnswer3")}
        </Typography>
      </Box>
    ),
  },
  {
    question: t("uiFaqAboutAfterpayAddToCheckoutQuestion"),
    answer: (
      <Box>
        <ol>
          <li>
            <Typography className={classes.paragraph} variant="body2">
              {t("uiFaqAboutAfterpayAddToCheckoutAnswer1")}
            </Typography>
          </li>
          <li>
            <Typography className={classes.paragraph} variant="body2">
              {t("uiFaqAboutAfterpayAddToCheckoutAnswer2")}
              <strong>{t("uiFaqAboutAfterpayAddToCheckoutAnswer3")}</strong>
            </Typography>
          </li>
          <li>
            <Typography className={classes.paragraph} variant="body2">
              {t("uiFaqAboutAfterpayAddToCheckoutAnswer4")}
            </Typography>
          </li>
        </ol>
        <Typography className={classes.paragraph} variant="body2">
          {`${t("uiFaqAboutAfterpayAddToCheckoutAnswer5")} `}
          <Link
            href={t("uiFaqAboutAfterpayAddToCheckoutUrl")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("uiFaqAboutAfterpayAddToCheckoutLinkText")}
          </Link>
        </Typography>
      </Box>
    ),
  },
  {
    question: t("uiFaqAboutAfterpayHowMuchChargeQuestion"),
    answer: (
      <Box>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqAboutAfterpayHowMuchChargeAnswer")}
          <MerchantAgreementLink linkOrigin="FAQ" product="Afterpay" />
        </Typography>
      </Box>
    ),
  },
];
